let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jPFt3")).then(() => parcelRequire('3QGFD'));